export default {
  loading: {
    id: 'bo_sellers-orders-drawers-fetching_data',
    defaultMessage: 'We are fetching your data',
  },
  billingAddress: {
    id: 'bo_sellers-orders-drawers-order_recap-billing_address-title',
    defaultMessage: 'Billing address',
  },
  shippingAddress: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_address-title',
    defaultMessage: 'Shipping address',
  },
} as const
